export default __webpack_public_path__ + "static/improved-developer-experience-22335f74073fa20d227b0d0105ba8786.svg";